import http from "../axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface JenisBerkasOption {
  id: number;
  kode: string;
  label: string;
  urutan: number;
  parent_id: number | null;
  level?: number;
}

export interface JenisBerkasManage extends JenisBerkasOption {
  aktif: boolean;
  berkas_count?: number;
  children_count?: number;
}

export interface JenisBerkasPayload {
  kode: string;
  label: string;
  urutan: number;
  aktif: boolean;
  parent_id: number | null;
}

export interface BerkasRm {
  id: number;
  pasien_rm: string;
  register_id: string | null;
  jenis_berkas_id: number;
  jenis_berkas_kode: string;
  jenis_berkas_label: string;
  sumber_tipe?: string | null;
  sumber_id?: number | null;
  nama_file: string;
  mime_type: string;
  file_size: number;
  keterangan: string | null;
  uploaded_by: number;
  uploader_name: string | null;
  created_at: string;
  scope: "pasien" | "register";
}

async function openFile(id: number): Promise<void> {
  const tab = window.open("", "_blank");

  try {
    const response = await http.getDataParam(`/berkas-rm/${id}/file`, {
      responseType: "blob"
    });

    const url = URL.createObjectURL(response.data as Blob);
    if (tab) tab.location.href = url;
    else window.open(url, "_blank");
  } catch (err) {
    if (tab) tab.close();
    return Promise.reject(err);
  }
}

async function list(
  pasienRm: string,
  params: {
    register_id?: string;
    scope?: "pasien" | "register";
    sumber_tipe?: string;
    sumber_id?: number;
  } = {}
): Promise<BerkasRm[]> {
  const response = await http
    .getDataParam(`/pasien/${pasienRm}/berkas-rm`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return (response.data || []) as BerkasRm[];
}

async function upload(pasienRm: string, data: FormData): Promise<BerkasRm> {
  const response = await http
    .postData(`/pasien/${pasienRm}/berkas-rm`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return response.data.data as BerkasRm;
}

async function remove(id: number) {
  const response = await http.deleteData(`/berkas-rm/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return response.data;
}

async function listJenisBerkas(): Promise<JenisBerkasOption[]> {
  const response = await http.getData(`/master/jenis-berkas`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return (response.data?.data || []) as JenisBerkasOption[];
}

// ── Kelola kategori (Super Admin) ────────────────────────────────────────────

async function listJenisBerkasManage(): Promise<JenisBerkasManage[]> {
  const response = await http.getData(`/master/jenis-berkas/manage`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });

  return (response.data?.data || []) as JenisBerkasManage[];
}

async function createJenisBerkas(data: JenisBerkasPayload): Promise<JenisBerkasManage> {
  const response = await http.postData(`/master/jenis-berkas`, data);
  return response.data.data as JenisBerkasManage;
}

async function updateJenisBerkas(
  id: number,
  data: JenisBerkasPayload
): Promise<JenisBerkasManage> {
  const response = await http.putData(`/master/jenis-berkas/${id}`, data);
  return response.data.data as JenisBerkasManage;
}

async function deleteJenisBerkas(id: number) {
  const response = await http.deleteData(`/master/jenis-berkas/${id}`);
  return response.data;
}

export default {
  list,
  upload,
  remove,
  openFile,
  listJenisBerkas,
  listJenisBerkasManage,
  createJenisBerkas,
  updateJenisBerkas,
  deleteJenisBerkas
};
